import { fetchCustomers, fetchFoodcourtStaff, fetchStaff } from '@services/api/users/userServices';
import { useQuery } from '@tanstack/react-query';
import { CustomersResponse, UserResponse,Staff } from 'types/users/userTypes';

export const useFoodcourtStaff=()=>{
    const {data,isLoading,error}=useQuery<UserResponse,Error>({
            queryKey:['foodcourtstaff'],
            queryFn:()=>fetchFoodcourtStaff(),
            refetchOnWindowFocus: false
    });
    return{
        data,
        isLoading,
        error
    }
}

export const useCustomers=()=>{
    const {data,isLoading,error}=useQuery<CustomersResponse,Error>({
            queryKey:['customers'],
            queryFn:()=>fetchCustomers(),
            refetchOnWindowFocus: false
    });
    return{
        data,
        isLoading,
        error
    }
}


export const useStaff=()=>{
    const {data,isLoading,error}=useQuery<Staff[],Error>({
            queryKey:['Adminstaff'],
            queryFn:()=>fetchStaff(),
            refetchOnWindowFocus: false
    });
    return{
        data,
        isLoading,
        error
    }
}
